import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';

export default {
  name: 'ChooseTeam',
  computed: {
    ...mapState('user', {
      choosingTeam: ({ choosingTeam }) => choosingTeam,
      gettingTeams: ({ gettingTeams }) => gettingTeams,
      teams: ({ teams }) => teams,
      token: ({ token }) => token,
    }),
  },
  async created() {
    if (!this.token) {
      this.$router.push('/login');
      return;
    }

    await this.getTeams();
  },
  methods: {
    ...mapActions('user', {
      chooseTeam: 'CHOOSE_TEAM',
      getTeams: 'GET_TEAMS',
    }),
    ...mapActions({
      resetState: 'reset',
    }),
    async choose(id) {
      try {
        await this.chooseTeam(id);
        this.$router.push('/menu');
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({ type: SNACKBAR_TYPES.ERROR, msg });
      }
    },
  },
};
